import React from 'react';
import {withTranslation} from 'react-i18next';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import ModalManager from './ModalManager';

class ModalWrapper extends React.Component {
  constructor(props) {
    super(props);
  }

  close() {
    ModalManager.close({
      isOpen: false
    });
  }

  render() {
    const {data} = this.props;
    return (
      <div>
        <Modal size={data.size} isOpen={data.isOpen} toggle={this.close}>
          <ModalHeader toggle={this.toggle}>{data.title}
          </ModalHeader>
          <ModalBody>{data.body}</ModalBody>
          {data.buttons && data.buttons.length ?
            <ModalFooter>
              {data.buttons.map(button => <Button color={button.color} onClick={button.onClick}>{button.text}</Button>)}
            </ModalFooter>
            :
            null
          }
        </Modal>
      </div>
    );
  }
}

export default withTranslation()(ModalWrapper);
